// Fires the indexnow-ping edge function at most once per 24h per browser.
// The edge function reads the live sitemap and submits every URL to Bing/Yandex/etc.

import { supabase } from "@/integrations/supabase/client";

const STORAGE_KEY = "indexnow_last_ping";
const INTERVAL_MS = 24 * 60 * 60 * 1000;

export async function pingIndexNowOncePerDay(): Promise<void> {
  if (typeof window === "undefined") return;
  if (window.location.hostname !== "www.fuel72.com") return;

  try {
    const last = Number(localStorage.getItem(STORAGE_KEY) ?? 0);
    if (Date.now() - last < INTERVAL_MS) return;
    localStorage.setItem(STORAGE_KEY, String(Date.now()));

    const { error } = await supabase.functions.invoke("indexnow-ping", { body: {} });
    if (error) console.warn("indexnow ping failed", error);
  } catch (err) {
    console.warn("indexnow ping skipped", err);
  }
}

export async function pingIndexNowUrls(urls: string[]): Promise<void> {
  if (urls.length === 0) return;
  const { error } = await supabase.functions.invoke("indexnow-ping", { body: { urls } });
  if (error) console.warn("indexnow ping failed", error);
}